export default __webpack_public_path__ + "static/media/640_business05-nl-web.2e56eee5.png";